import { InjectionToken } from '@angular/core';
import {
    DatiqAnalyticsActionTypes,
    DatiqAnalyticsApplicationMode,
    DatiqAnalyticsEventTemplateKeys,
    DatiqAnalyticsInitiator,
    DatiqAnalyticsInputInteraction,
    DatiqAnalyticsPropsIdentifyKeys,
    DatiqAnalyticsPropsPageKeys,
    DatiqAnalyticsTrackingEventKeys,
    DatiqAnalyticsTrackPropertiesKey,
} from './datiq-analytics.enum';
import { IDatiqAction } from './datiq-app.interface';

export type DatiqAnalyticsInputValueType =
    | string
    | Date
    | boolean
    | number
    | null;
export interface IDatiqAnalyticsEventInputInfo {
    inputId: string;
    interaction: DatiqAnalyticsInputInteraction;
    label?: string;
    value?: unknown;
    settings?: unknown;
    props?: unknown;
}

export interface IDatiqAnalyticsPropsTrack {
    [DatiqAnalyticsTrackPropertiesKey.ApplicationMode]: DatiqAnalyticsApplicationMode;
    [DatiqAnalyticsTrackPropertiesKey.ApplicationVersion]: string;
    [DatiqAnalyticsTrackPropertiesKey.CsbUserId]?: number;
    [DatiqAnalyticsTrackPropertiesKey.DatPrimaryApplication]: string;
    [DatiqAnalyticsTrackPropertiesKey.Email]: string;
    [DatiqAnalyticsTrackPropertiesKey.Initiator]: DatiqAnalyticsInitiator;
    [DatiqAnalyticsTrackPropertiesKey.InteractionGesture]: DatiqAnalyticsInputInteraction;
    [DatiqAnalyticsTrackPropertiesKey.Page]: string;
    [DatiqAnalyticsTrackPropertiesKey.TrackingVersion]: string;
    [DatiqAnalyticsTrackPropertiesKey.UiLabel]: string;
    [DatiqAnalyticsTrackPropertiesKey.UiLocation]: string;
}
export interface IDatiqAnalyticsPropsIdentify {
    [DatiqAnalyticsPropsIdentifyKeys.ApplicationMode]: DatiqAnalyticsApplicationMode;
    [DatiqAnalyticsPropsIdentifyKeys.ApplicationVersion]: string;
    [DatiqAnalyticsPropsIdentifyKeys.CsbUserId]?: number;
    [DatiqAnalyticsPropsIdentifyKeys.DatPrimaryApplication]: string;
    [DatiqAnalyticsPropsIdentifyKeys.Email]: string;
    [DatiqAnalyticsPropsIdentifyKeys.Name]: string;
    [DatiqAnalyticsPropsIdentifyKeys.TrackingVersion]: string;
    [DatiqAnalyticsPropsIdentifyKeys.UserId]: string;
    [key: string]: boolean | string | number;
}
export interface IDatiqAnalyticsPropsPage {
    [DatiqAnalyticsPropsPageKeys.ApplicationMode]: DatiqAnalyticsApplicationMode;
    [DatiqAnalyticsPropsPageKeys.ApplicationVersion]: string;
    [DatiqAnalyticsPropsPageKeys.CsbUserId]?: number;
    [DatiqAnalyticsPropsPageKeys.BrowserBreakpointSize]: string;
    [DatiqAnalyticsPropsPageKeys.BrowserHeight]: string;
    [DatiqAnalyticsPropsPageKeys.BrowserLanguage]: string;
    [DatiqAnalyticsPropsPageKeys.BrowserUserAgent]: string;
    [DatiqAnalyticsPropsPageKeys.BrowserWidth]: string;
    [DatiqAnalyticsPropsPageKeys.ScreenHeight]: string;
    [DatiqAnalyticsPropsPageKeys.ScreenWidth]: string;
    [DatiqAnalyticsPropsPageKeys.DatPrimaryApplication]: string;
    [DatiqAnalyticsPropsPageKeys.Email]: string;
    [DatiqAnalyticsPropsPageKeys.Initiator]: DatiqAnalyticsInitiator;
    [DatiqAnalyticsPropsPageKeys.Page]: string;
    [DatiqAnalyticsPropsPageKeys.TrackingVersion]: string;
    [DatiqAnalyticsPropsPageKeys.Source]: string;
}

export interface IDatiqAnalyticsEvent {
    eventName: string;
    inputInfo: IDatiqAnalyticsEventInputInfo;
}

export interface IDatiqAnalyticsEventTrackRow {
    [DatiqAnalyticsTrackingEventKeys.GlobalId]: string;
    [DatiqAnalyticsTrackingEventKeys.PreImplementationStatus]: string;
    [DatiqAnalyticsTrackingEventKeys.ChangeType]: string;
    [DatiqAnalyticsTrackingEventKeys.Id]: string;
    [DatiqAnalyticsTrackingEventKeys.Ticket]: string;
    [DatiqAnalyticsTrackingEventKeys.Status]: string;
    [DatiqAnalyticsTrackingEventKeys.Priority]: string;
    [DatiqAnalyticsTrackingEventKeys.Initiator]: string;
    [DatiqAnalyticsTrackingEventKeys.EventName]: string;
    [DatiqAnalyticsTrackingEventKeys.Page]: string;
    [DatiqAnalyticsTrackingEventKeys.Location]: string;
    [DatiqAnalyticsTrackingEventKeys.TrackingType]: DatiqAnalyticsActionTypes;
    [DatiqAnalyticsTrackingEventKeys.SpecificProperties]: string;
}

export interface IDatiqAnalyticsEventTemplateValues {
    [DatiqAnalyticsEventTemplateKeys.AppRoot]: string;
}

export interface IDatiqAnalyticsEventTrack {
    row: IDatiqAnalyticsEventTrackRow;
    analyticEvent: IDatiqAnalyticsEvent;
}
export interface IDatiqAnalytics {
    trackingEvents: IDatiqAnalyticsEventTrack[];
    loaded: boolean;
}

export interface IDatiqAnalyticsConfig {
    trackingEvents?: IDatiqAnalyticsEventTrack[];
    trackingPlanSheetId?: string;
}

export interface IDatiqAnalyticsMatchingEvent{
    trackingEvent: IDatiqAnalyticsEventTrack; // The event from tracking plan
    analyticsEvent: IDatiqAnalyticsEvent; // The event from the state
}

export interface IDatiqAnalyticsService {
    handleAction(action: IDatiqAction): void;
}

export const ANALYTICS_SERVICE: InjectionToken<IDatiqAnalyticsService> = new InjectionToken<IDatiqAnalyticsService>('Analytics Service');
